import classnames from 'classnames'
import { useState } from 'react'

import { WAIT_LIST_REQUESTED } from 'dashboard-subscriptions/constants'
import { formatToDate } from 'shared/time-utilites'

import Button from '@components/Button'
import CircleLoader from '@components/CircleLoader'
import IconButton from '@components/IconButton'
import TableCell from '@components/TableCell'
import styles from './styles.module.scss'
import WaitListModal from './WaitListModal'

export const WaitList = ({ waitList }) => {
    const [showModal, setShowModal] = useState(false)
    const [waitListId, setWaitListId] = useState('')
    const openModal = id => {
        setShowModal(true)
        setWaitListId(id)
    }
    return (
        <>
            {showModal && <WaitListModal closeModal={() => setShowModal(false)} waitListId={waitListId} />}
            {waitList.map(({ id, productCd, createdDate, locationName, state }) => (
                <div key={id} className={styles.tableRow}>
                    <TableCell fieldName={<T>dashboard.label.product</T>} className={styles.productName}>
                        {productCd}
                    </TableCell>
                    <TableCell fieldName={<T>dashboard.label.created.date</T>} className={styles.date}>
                        {formatToDate(createdDate)}
                    </TableCell>
                    <TableCell fieldName={<T>dashboard.label.location</T>} className={styles.location}>
                        {locationName === undefined ? <CircleLoader size="small" /> : locationName}
                    </TableCell>
                    <TableCell
                        fieldName={<T>dashboard.label.status</T>}
                        className={classnames(styles.state, styles[state.toLowerCase()])}>
                        <T>{`dashboard.label.state.${state.toLowerCase()}`}</T>
                    </TableCell>
                    <TableCell fieldName={<T>dashboard.label.actions</T>} className={styles.action}>
                        {state === WAIT_LIST_REQUESTED && (
                            <div onClick={() => openModal(id)} className="d-inline-table">
                                <span className="d-none d-md-inline">
                                    <IconButton icon="trash-inactive" />
                                </span>
                                <div className="d-md-none">
                                    <Button iconLeft="trash-inactive" size="small" className="mt-1">
                                        <T>dashboard.label.delete</T>
                                    </Button>
                                </div>
                            </div>
                        )}
                    </TableCell>
                </div>
            ))}
        </>
    )
}

export default WaitList
